import { resolveI18n } from "../../commons/services/Translation"

export const LabelWidthClass = (i18n) => {
  return resolveI18n({ i18n, ko: "w150", en: "w180", vi: "w180" })
}